// import { convertDate, getTokenId } from '@/utils';
// import { COMPONENTS } from '@/utils/list-generators';
import { useLazyQuery, useResult } from '@vue/apollo-composable';
import { computed, onMounted, ref } from '@vue/composition-api';
import notificationsScheme from './item.graphql';
import convertDate from '@/utils/convertDate';
import useAuth from '@/api/auth';

export const NOTIFICATION_TYPES = {
  NOTICE: 'NOTICE',
  ALERT: 'ALERT',
  ALERT_TRIGGERED: 'ALERT_TRIGGERED',
  MESSAGE: 'MESSAGE'
};

const NOTIFICATION_ICONS = {
  [NOTIFICATION_TYPES.NOTICE]: '$notice',
  [NOTIFICATION_TYPES.ALERT]: '$alert',
  [NOTIFICATION_TYPES.ALERT_TRIGGERED]: '$alert',
  [NOTIFICATION_TYPES.MESSAGE]: '$message'
};

export function getNotificationType(notificationTags = []) {
  if (notificationTags.includes('alert')) {
    if (notificationTags.includes('triggered')) {
      return NOTIFICATION_TYPES.ALERT_TRIGGERED;
    }
    return NOTIFICATION_TYPES.ALERT;
  } else if (notificationTags.includes('message')) {
    return NOTIFICATION_TYPES.MESSAGE;
  } else {
    return NOTIFICATION_TYPES.NOTICE;
  }
}

export function genNotificationItem({ text, subTitle, type }) {
  return {
    title: text,
    subTitle,
    icon: NOTIFICATION_ICONS[type],
    iconColor: type === NOTIFICATION_TYPES.ALERT_TRIGGERED ? 'red' : undefined
  };
}

export function useNotificationsCurrentUser() {
  // const user = inject('user');
  const hasNew = ref(false);

  const { profile } = useAuth();
  const audio = new Audio('/notify.mp3');

  const {
    result,
    load,
    loading,
    fetchMore,
    subscribeToMore,
    restart,
    variables
  } = useLazyQuery(
    notificationsScheme.fetchNotificationsDeliveries,
    {
      condition: {
        user: '',
        deliveryPath: ''
      }
    },
    {
      fetchPolicy: 'cache-and-network',
      nextFetchPolicy: 'cache-only'
    }
  );

  const notificationsConnections = useResult(
    result,
    {
      nodes: [],
      pageInfo: {}
    },
    data => data.notificationDeliveriesConnection
  );

  const loadMore = async state => {
    const result = await fetchMore({
      variables: {
        after: notificationsConnections.value.pageInfo.endCursor
      }
    });

    if (result.data.notificationDeliveriesConnection.pageInfo.hasNextPage) {
      state.loaded();
    } else {
      state.complete();
    }
  };

  let subscribeVariables = ref({
    deliveryUser: '',
    deliveryPath: ''
  });

  subscribeToMore({
    document: notificationsScheme.listenNotifications,
    variables: subscribeVariables,
    updateQuery: (previousResult, { subscriptionData }) => {
      const relatedNode = subscriptionData.data?.Notifications?.relatedNode;
      const targetProfile = profile.value.objectsToObjectsByObject1Id.find(
        item => item.object2.deliveryChannel === 'In-app'
      );

      const notificationsSoundInTheApp = targetProfile?.object2?.objectProperties.find(
        item => item.key === 'settingsSoundInTheApp'
      ) || { value: false };
      if (relatedNode.notification) {
        hasNew.value = true;

        if (notificationsSoundInTheApp.value) {
          audio.play();
        }

        return {
          notificationDeliveriesConnection: {
            nodes: [
              relatedNode,
              ...previousResult.notificationDeliveriesConnection.nodes
            ],
            pageInfo: previousResult.notificationDeliveriesConnection.pageInfo
          }
        };
      }
      return previousResult;
    }
  });

  const listItems = computed(() =>
    notificationsConnections.value.nodes.map(i => {
      return {
        id: i.notification.id,
        ...genNotificationItem({
          text: i.message,
          subTitle: `${convertDate(i.notification.createdAt)} by ${i
            .notification.userByBy.mName || i.notification.userByBy.login}`,
          type: getNotificationType(i.notification.tags)
        })
      };
    })
  );

  onMounted(() => {
    if (localStorage.getItem('pixelHasNew') === '0') {
      hasNew.value = false;
    }
  });

  return {
    listItems,
    loadMore,
    load,
    loading,
    result,
    hasNew,
    restart,
    variables,
    notificationsConnections,
    subscribeVariables
  };
}
